import { Capacitor } from '@capacitor/core';

/**
 * Dynamic API Base URL
 *
 * Resolution order:
 * 1. REACT_APP_API_URL (full API base, e.g. https://api.voice-ride.com/api)
 * 2. REACT_APP_BACKEND_URL (server root, /api appended automatically)
 * 3. Platform auto-detect:
 *    - Android native → https://api.voice-ride.com
 *    - Browser local  → http://localhost:8000
 */
function resolveBackendUrl() {
  // REACT_APP_API_URL = full API base URL (no /api suffix added)
  const apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl && apiUrl !== '') {
    return { backend: apiUrl, api: apiUrl };
  }

  // REACT_APP_BACKEND_URL = server root (/api is appended)
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl && backendUrl !== '' && !backendUrl.includes('localhost') && !backendUrl.includes('10.0.2.2')) {
    return { backend: backendUrl, api: `${backendUrl}/api` };
  }

  // Native Android (Capacitor) — falls keine env-vars, nutze Production-Domain
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
    const base = backendUrl || 'https://voice-ride.com';
    return { backend: base, api: `${base}/api` };
  }

  // Fallback: browser / local dev
  const base = backendUrl || 'http://localhost:8000';
  return { backend: base, api: `${base}/api` };
}

const resolved = resolveBackendUrl();

export const BACKEND_URL = resolved.backend;
export const API = resolved.api;

// Socket.IO — single source of truth for the connection path
export const SOCKET_IO_PATH = '/api/socket.io/';
// Legacy export (kept for backward compat)
export const WS_URL = BACKEND_URL;
